import React from 'react'
import Footer from '../components/Footer'
import Header from '../components/Header'
import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { FiArrowRight, FiExternalLink } from 'react-icons/fi';
import styled from 'styled-components';

// Styled Components for better visual cues
const ServiceCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 30px;
  box-shadow: 0 5px 20px rgba(0,0,0,0.08);
  transition: all 0.3s ease;
  border: 2px solid transparent;
  position: relative;
  overflow: hidden;
  cursor: pointer;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 15px 40px rgba(0,0,0,0.15);
    border-color: #f7bf68;
  }

  &:hover .learn-more-btn {
    background: #f7bf68;
    color: white;
    transform: translateX(5px);
  }

  &:hover .service-icon {
    transform: scale(1.1);
  }

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    height: 4px;
    background: linear-gradient(90deg, #f7bf68, #e6a23c);
    transform: scaleX(0);
    transition: transform 0.3s ease;
  }

  &:hover::before {
    transform: scaleX(1);
  }
`;

const ServiceIcon = styled.div`
  width: 80px;
  height: 80px;
  background: linear-gradient(135deg, #f7bf68, #e6a23c);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
  transition: transform 0.3s ease;
  
  img {
    width: 40px;
    height: 40px;
    filter: brightness(0) invert(1);
  }
`;

const ServiceTitle = styled.h3`
  color: #333;
  font-size: 24px;
  font-weight: 700;
  margin-bottom: 15px;
  transition: color 0.3s ease;
  
  &:hover {
    color: #f7bf68;
  }
`;

const ServiceDescription = styled.p`
  color: #666;
  line-height: 1.6;
  margin-bottom: 20px;
  font-size: 16px;
`;

const LearnMoreButton = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  background: transparent;
  color: #f7bf68;
  border: 2px solid #f7bf68;
  padding: 12px 24px;
  border-radius: 25px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.3s ease;
  cursor: pointer;
  
  &:hover {
    background: #f7bf68;
    color: white;
    transform: translateX(5px);
  }
`;

const ClickableHint = styled.div`
  text-align: center;
  margin-top: 15px;
  padding: 10px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #f7bf68;
  font-size: 14px;
  color: #666;
  font-style: italic;
`;

export const Plans = [
    {
        title: "Manage Your Credit",
        icon: "/assets/images/icons/icon-18.png",
        overlayIcon: "/assets/images/icons/icon-18.png",
        linkIcon: "/assets/images/icons/icon-15.png",
        description:
            "Take control of your financial future with Ravline Corps comprehensive credit solutions for both individuals and businesses. Our credit restoration services are designed to help you repair, rebuild, and strategically grow your credit profile whether personal or business. We offer personal credit restoration by challenging and removing inaccurate or outdated items from your credit report, business credit building to secure funding and vendor relationships, and strategic credit planning customized to your goals like buying a home or funding a business. Good credit provides access, leverage, and long-term wealth building, and we're here to help you establish, strengthen, and sustain it with confidence.",
    },
    {
        title: "Start-Up & Business Growth",
        icon: "/assets/images/icons/icon-new10.png",
        overlayIcon: "/assets/images/icons/icon-new10.png",
        linkIcon: "/assets/images/icons/icon-15.png",
        description: "Whether you're launching your first business or scaling an existing company, Ravline Corp provides the tools, strategies, and expert guidance to help you build smart and grow strong. Our services include business formation and structure (from LLCs to S Corporations aligned with your tax strategy), business planning with market research and financial projections to attract investors, credit and lending readiness for SBA or private financing, and compliance setup including EIN/TAX ID, NAICS codes, and trust integration for scalability and protection. We don't just help you start a business we help you build a legacy, whether as a solopreneur, growing enterprise, or aiming for government contracts."
    },
    {
        title: "Life, Health, & Annuity Insurance",
        icon: "/assets/images/icons/icon-new10.png",
        overlayIcon: "/assets/images/icons/icon-new10.png",
        linkIcon: "/assets/images/icons/icon-15.png",
        description: "Protect what matters most your life, your legacy, and your future. Ravline Corp offers tailored insurance solutions that go beyond coverage, helping you build a financial safety net while supporting long-term wealth creation and tax efficiency. Our services include life insurance (from Term to Whole Life and Indexed Universal Life for protection, cash value growth, and estate planning), health insurance (affordable coverage for self-employed, small businesses, or families, including HSAs), and annuities (fixed, indexed, and variable for guaranteed retirement income with tax-deferred growth). Insurance is a strategy that protects assets, reduces tax exposure, and funds opportunities, integrated into your bigger financial picture by our licensed wealth consultants."
    },
    {
        title: "Real Estate & Mortgage Consulting Services",
        icon: "/assets/images/icons/icon-new10.png",
        overlayIcon: "/assets/images/icons/icon-new10.png",
        linkIcon: "/assets/images/icons/icon-15.png",
        description: "Whether you're buying your first home, investing in property, or building a real estate portfolio, Ravline Corp offers strategic guidance every step of the way. As licensed professionals, we provide expert insight into residential and commercial real estate with a focus on wealth-building, tax strategy, and smart financing. Our services include homebuyer and investor guidance (from credit readiness to closing support), mortgage consulting (understanding rates, comparing loans, and optimizing financing), real estate investment strategy (structuring rentals for tax efficiency and passive income), and real estate tax code education (Section 121 exclusions to 1031 exchanges). We align your real estate goals with your financial future, whether as a first-time buyer or seasoned investor."
    }
];

export default function CreditandFinancialSolutions() {
    const [isLoading, setIsLoading] = useState(true);

    const getRoute = (title) => {
        switch (title) {
            case "Manage Your Credit":
                return "/manage-your-credit";
            case "Start-Up & Business Growth":
                return "/startup-business-growth";
            case "Life, Health, & Annuity Insurance":
                return "/life-health-annuity-insurance";
            case "Real Estate & Mortgage Consulting Services":
                return "/real-estate-mortgage-consulting";
            default:
                return "/";
        }
    };

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false)
        }, 1000);
    }, []);

    return (
        <div className="boxed_wrapper ltr">
            {isLoading && <div className="loader-wrap">
                <div className="preloader">
                    <div className="preloader-close">close</div>
                    <div id="handle-preloader" className="handle-preloader">
                        <div className="animation-preloader">
                            <div className="txt-loading">
                                <img src="assets/images/animation_logo.gif" alt="img" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
            <div>
                <div id="search-popup" className="search-popup">
                    <div className="popup-inner">
                        <div className="upper-box">
                            <figure className="logo-box"><a href="index.html"><img src="assets/images/logo-2.png" alt="" /></a></figure>
                            <div className="close-search"><span className="fas fa-times"></span></div>
                        </div>
                        <div className="overlay-layer"></div>
                        <div className="auto-container">
                            <div className="search-form">
                                <form method="post" action="index.html">
                                    <div className="form-group">
                                        <fieldset>
                                            <input type="search" className="form-control" name="search-input" defaultValue="Read-only content" placeholder="Type your keyword and hit" required />
                                            <button type="submit"><i className="fas fa-search"></i></button>
                                        </fieldset>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>

                <Header />

                {/* page-title */}
                <section className="page-title">
                    <div
                        className="bg-layer"
                        style={{
                            backgroundImage: `url("/assets/images/background/page-title.jpg")`,
                        }}
                    ></div>
                    <div className="line-grid-wrap">
                        <span className="line-grid-1"></span>
                        <span className="line-grid-2"></span>
                        <span className="line-grid-3"></span>
                        <span className="line-grid-4"></span>
                        <span className="line-grid-5"></span>
                    </div>
                    <div className="auto-container">
                        <div className="content-box">
                            <h1 style={{ textAlign: "left" }}>Credit and Financial Solutions</h1>
                            <ul className="bread-crumb clearfix">
                                <li>
                                    <Link to="/">Home</Link>
                                </li>
                                <li>Credit and Financial Solutions</li>
                            </ul>
                        </div>
                    </div>
                </section>
                {/* Page Title End */}

                {/* Service Section */}
                <section
                    className="service-section service-page-1"
                    style={{ textAlign: "left", padding: "80px 0" }}
                >
                    <div className="auto-container">
                        <div className="inner-container">
                            <div className="sec-title" style={{ marginBottom: "50px" }}>
                                <span className="sub-title mb_12">What We Do</span>
                                <h2>Credit and Financial Solutions</h2>
                                <p>
                                    Manage your finances effectively with tools for budgeting,
                                    credit restoration, and debt payoff. Protect your identity and
                                    assets with credit monitoring, legal services. Achieve your financial goals with net worth tracking,
                                    savings planning.
                                </p>
                            </div>
                            <div className="row clearfix">
                                {Plans.map((plan, index) => (
                                    <div
                                        key={index}
                                        className="col-lg-6 col-md-6 col-sm-12 service-block"
                                        style={{ marginBottom: "30px" }}
                                    >
                                        <Link
                                            to={getRoute(plan.title)}
                                            state={{ plan }}
                                            style={{ textDecoration: 'none' }}
                                        >
                                            <ServiceCard>
                                                <ServiceIcon className="service-icon">
                                                    <img src={plan.icon} alt={plan.title} />
                                                </ServiceIcon>
                                                <ServiceTitle>{plan.title}</ServiceTitle>
                                                <ServiceDescription>{plan.description}</ServiceDescription>
                                                
                                                <LearnMoreButton className="learn-more-btn">
                                                    Learn More <FiArrowRight />
                                                </LearnMoreButton>
                                                
                                                
                                            </ServiceCard>
                                        </Link>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
                {/* service-section end */}

                {/* main-footer */}
                <Footer />
                {/* main-footer end */}

                {/* Scroll to top */}
                <div className="scroll-to-top" onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} style={{ cursor: 'pointer' }}>
                    <div>
                        <div className="scroll-top-inner">
                            <div className="scroll-bar">
                                <div className="bar-inner"></div>
                            </div>
                            <div className="scroll-bar-text">Go To Top</div>
                        </div>
                    </div>
                </div>
                {/* Scroll to top end */}
            </div>
        </div>
    )
}